import { createSelector } from 'reselect';

import { type ApplicationState } from '../store';

const getBillingStore = (state: ApplicationState) => state.billing;

export const showCreditCardModal = createSelector(
  getBillingStore,
  (billingStore) => billingStore.showCreditCardModal,
);

export const getPaymentMethods = createSelector(
  getBillingStore,
  (billingStore) => billingStore.paymentMethods,
);

export const getBillingFrequency = createSelector(
  getBillingStore,
  (billingStore): number | undefined => billingStore.paymentMethods.billingFrequency,
);

export const getPaymentThreshold = createSelector(
  getBillingStore,
  (billingStore): number | undefined => billingStore.paymentMethods.paymentThreshold,
);
